module.exports = __webpack_public_path__ + "media/images/illustration/undraw_at_home_octe-4d40a4cef177dc7782dcc0eae4f546eb.svg";